import React from "react";
import "@/App.css";
import { BookingProvider } from "./components/BookingModal";
import SmoothScroll from "./components/SmoothScroll";
import Cursor from "./components/Cursor";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import Intro from "./components/Intro";
import Services from "./components/Services";
import Courses from "./components/Courses";
import { InteriorGallery, WorkGallery } from "./components/Galleries";
import StudentsSection from "./components/StudentsSection";
import Footer from "./components/Footer";

function App() {
  return (
    <BookingProvider>
      <SmoothScroll>
        <div className="App grain">
          <Cursor />
          <Nav />
          <main>
            <Hero />
            <Intro />
            <Services />
            <Courses />
            <InteriorGallery />
            <StudentsSection />
            <WorkGallery />
          </main>
          <Footer />
        </div>
      </SmoothScroll>
    </BookingProvider>
  );
}

export default App;
